export default __webpack_public_path__ + "static/media/register-page-carousel.cc7f91c5.png";